import React from "react";
import PeerLogo from "../../../assets/images/peerislands.svg";
import PeerAILogo from "../../../assets/images/peerai_white.png";
import "./Sidebar.scss";
import { IoAddOutline } from "react-icons/io5";
import PropTypes from "prop-types";
import { IoTrashOutline } from "react-icons/io5";
import { IoRefreshCircleSharp } from "react-icons/io5";
import {  Link } from "react-router-dom";
import { AiOutlineFileSearch } from "react-icons/ai";



// PropTypes validation
Sidebar.propTypes = {
  data: PropTypes.array,
  activeId: PropTypes.string.isRequired,
  handleActiveChat: PropTypes.any.isRequired,
  newSession: PropTypes.any.isRequired,
  setData:PropTypes.any.isRequired
};

export default function Sidebar({
  data,
  activeId,
  handleActiveChat,
  newSession,
  setData
}) {
  const deleteSession = async (session_id) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/chat_routers/deleteSession/${session_id}`, {
      method: "DELETE",
    });
    const res = await response.json();
    if (res === 1) {
      console.log("Setting data");
      setData((prevData) => 
        prevData.filter(item => item.session_id !== session_id) 
      );
    }
  };
  
  return (
    <div className="column form-column">
          {console.log("rendering due to updation",data)}
      <div className="top">
        <div className="header">
          <div className="logo">
            <img src={PeerLogo} alt="logo" />
            <div className="divider"></div>
            <img src={PeerAILogo} alt="logo" />
          </div>
          <div className="add" onClick={() => newSession()}>
            <IoAddOutline />
          </div>
        </div>

        <ul className="menu">
          {data?.map((item, i) => {
            return (
              <li key={i} className="sessions">
                <p
                  className={item.session_id === activeId ? "active" : ""}
                  onClick={() => {
                    handleActiveChat(item.session_id);
                  }}
                >
                  {item.session_Summary?item.session_Summary:"New Conversation"}   
                  {/* updated here  */}
                </p>
                <IoTrashOutline style={{cursor:"pointer"}} onClick={async()=>{await deleteSession(item.session_id)}}/>
              </li>
            );    
          })}
        </ul>   
      </div>
      <div className="direct">
      <IoRefreshCircleSharp  size={50} style={{cursor:"pointer",paddingBottom:"10px"}} onClick={()=>{window.location.reload()}} color="blue"/>
      <Link to="/actions">
        <AiOutlineFileSearch size={35} className="button" label="Actions"  />
        </Link> 
        </div>
    </div>
  );
}
